import imageCompression from "browser-image-compression";

// typings
import {
  EContractType,
  ECurrency,
  EFeePayee,
  EReturnPolicy,
  ESenderRole,
  EShipmentType,
  IContractDetailsBody,
  ItemDetailsDTO,
} from "../api/services/contract/models";

export const contractBody = (
  title: ItemDetailsDTO["title"],
  description: ItemDetailsDTO["description"],
  price: IContractDetailsBody["itemPrice"],
  shippingFee: IContractDetailsBody["shipment"]["fee"],
  // feePayee: EFeePayee,
  // inspectionPeriod: ItemDetailsDTO["inspectionPeriod"],
  // deliveryInDays: ItemDetailsDTO["deliveryInDays"],
  termsAccepted: boolean,
  shipmentType: EShipmentType
): IContractDetailsBody => {
  return {
    type: EContractType.QUICK_TRANSACTION,
    senderRole: ESenderRole.PROVIDER,
    itemDetail: {
      title: title,
      description: description,
      images: [],
    },
    itemPrice: price,
    currency: ECurrency.SAR,
    // feePayee: feePayee,
    // inspectionPeriod: inspectionPeriod,
    shipment: {
      type: shipmentType,
      fee: shippingFee,
      currency: ECurrency.SAR,
      // deliveryInDays: deliveryInDays,
    },
    returnPolicy: EReturnPolicy.NO_RETURN,
    returnFeePayee: EFeePayee.PROVIDER,
    receiverId: "",
    receiverName: "",
    waffyTermsAccepted: termsAccepted,
  };
};

export const handleCompressImage = async (
  imageFile: File | undefined
): Promise<File | void> => {
  if (!imageFile) return;

  const options = {
    maxSizeMB: 2,
    maxWidthOrHeight: 1920,
  };

  try {
    const compressedFile = await imageCompression(imageFile, options);
    return compressedFile;
  } catch (error) {
    console.log(error);
    return;
  }
};
